/* =====================================================================
   Bluewud × Empire v13 — product gallery bridge.
   The native <product-gallery> (Swiper) renders fine — thumbnails load in a
   grid below the main image and thumbnail clicks navigate the viewer — but two
   native behaviours are dead in this theme:
     1. the main viewer ships with allowTouchMove:false (no swipe), and
     2. the variant picker never tells the gallery to move to the selected
        colour's image (the native variant JS is inert, same as the cart).
   This bridges both without touching the compiled component. It reads a small
   variant→media-id map embedded by snippets/product.gallery.liquid (no /products.js
   fetch, so nothing loads "a lot of time after the page"). All work is feature
   detected, so products with 0 / 1 / many images and variants without their own
   image degrade gracefully.
   ===================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function readVariantData() {
    var el = document.querySelector('[data-bw-variant-media]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function enableSwipe(sw) {
    try {
      sw.allowTouchMove = true;
      if (sw.params) {
        sw.params.allowTouchMove = true;
        sw.params.simulateTouch = true;   // mouse-drag on desktop
        sw.params.grabCursor = true;
      }
      if (typeof sw.update === 'function') sw.update();
    } catch (e) {}
  }

  function init() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    var viewerEl = gallery.querySelector('.product-gallery__viewer');
    if (!viewerEl) return;

    // The component initialises Swiper asynchronously — wait for it.
    var tries = 0;
    (function waitSwiper() {
      var sw = viewerEl.swiper;
      if (sw) { onReady(viewerEl, sw); return; }
      if (tries++ > 80) return;            // ~8s safety cap
      setTimeout(waitSwiper, 100);
    })();
  }

  function onReady(viewerEl, sw) {
    enableSwipe(sw);
    // Re-assert once more after the component settles (it may reset on layout).
    setTimeout(function () { enableSwipe(sw); }, 600);

    var data = readVariantData();
    if (!data || !data.variants || !data.optionNames) return;

    function slideToMediaId(mediaId) {
      if (mediaId == null) return;
      var slides = viewerEl.querySelectorAll('.swiper-slide[data-media-id]');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
          sw.slideTo(i);
          return;
        }
      }
    }

    function selectedValueFor(name) {
      var r = document.querySelector(
        'input[type="radio"][name="' + name + '"]:checked, ' +
        'input[type="radio"][name="options[' + name + ']"]:checked'
      );
      if (r) return r.value;
      var s = document.querySelector(
        'select[name="' + name + '"], select[name="options[' + name + ']"]'
      );
      return s ? s.value : null;
    }

    function currentVariant() {
      var selected = data.optionNames.map(selectedValueFor);
      return data.variants.filter(Boolean).find(function (v) {
        return v.options && v.options.length === selected.length &&
          v.options.every(function (val, i) { return val === selected[i]; });
      });
    }

    function syncGallery() {
      var v = currentVariant();
      if (!v) return;
      if (v.media_id != null) slideToMediaId(v.media_id);
      // Keep the product form's variant id in sync so Add-to-cart / Buy-it-now
      // post the SELECTED colour. The ported v6 variants-ui markup isn't wired
      // to v13's variant JS, so without this the <select name="id"> keeps the
      // default variant and the wrong colour gets added.
      if (v.id != null) {
        var idEl = document.querySelector('select[name="id"], input[name="id"]');
        if (idEl && String(idEl.value) !== String(v.id)) {
          idEl.value = v.id;
          idEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // The variants-ui option header renders server-side as
    // `Color: <span>Wenge</span>` and empire.js never repaints it in this build,
    // so the colour NAME stayed stuck on the default variant no matter which
    // swatch was clicked. Repaint each option's label from its own checked radio.
    // Scoped per <fieldset> so multi-option products (Color + Size) stay correct.
    function syncOptionLabels() {
      var labels = document.querySelectorAll('.variants-ui__option-name, .option-name');
      Array.prototype.forEach.call(labels, function (nameEl) {
        var fieldset = nameEl.closest('fieldset');
        if (!fieldset) return;
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var span = nameEl.querySelector('span');
        if (span) span.textContent = checked.value;
        var values = fieldset.querySelector('[data-variant-option]');
        if (values) values.setAttribute('data-variant-option-chosen-value', checked.value);
      });
    }

    function syncAll() { syncGallery(); syncOptionLabels(); }

    // Radios/selects fire change; swatch labels fire click — cover both.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && (t.matches('input[type="radio"]') || t.matches('select'))) syncAll();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('label, [data-swatch], .swatch')) setTimeout(syncAll, 60);
    });
    syncOptionLabels();
  }

  ready(init);
})();
